import { Box, BoxProps, Container } from '@material-ui/core';
import { ReactNode } from 'react';

import { useScreen } from '@/hooks/useScreen';

interface ApplicationStepContentProps extends BoxProps {
  children?: ReactNode;
}

export const ApplicationStepContainer = ({ children, ...boxProps }: ApplicationStepContentProps) => {
  const { sm } = useScreen();

  return (
    <Container maxWidth={'lg'} style={{ padding: 0 }}>
      <Box display={'flex'} flexDirection={'column'} gridGap={sm ? 34 : 46} {...boxProps}>
        {children}
      </Box>
    </Container>
  );
};
